import { observer } from 'mobx-react';
import { DndContext, DragEndEvent, DragOverlay, DragStartEvent } from '@dnd-kit/core';
import { restrictToHorizontalAxis, restrictToParentElement } from '@dnd-kit/modifiers';
import DraggableCategory from 'src/view/screens/MenuManagementScreen/screens/MenuGroupEditScreen/components/DraggableCategory/DraggableCategory';
import ScrollableBlock from 'src/view/containers/ScrollableBlock/ScrollableBlock';
import menuGroupEditStore from 'src/view/screens/MenuManagementScreen/screens/MenuGroupEditScreen/store/menuGroupEditStore';
import { IMenuGroupCategory } from 'src/view/screens/MenuManagementScreen/screens/MenuGroupsScreen/types/menuGroups';
import { dndAutoScrollOptionsDefault, dndOverlayAnimationDefault, DndSensors } from 'src/utils/dnd';
import './style.scss';

interface IProps {
  categories: IMenuGroupCategory[];
}

const MenuGroupCategories = observer(({ categories }: IProps): JSX.Element => {
  const dndSensors = DndSensors();

  const hanldeDragStart = ({ active }: DragStartEvent) => {
    menuGroupEditStore.setDraggingCategory(+active.id);
  };

  const handleDragEnd = ({ active, over }: DragEndEvent) => {
    menuGroupEditStore.changeCategoriesSorting(+active.id, over ? +over.id : null);
  };

  return (
    <DndContext
      id="category"
      autoScroll={dndAutoScrollOptionsDefault}
      sensors={dndSensors}
      modifiers={[restrictToHorizontalAxis, restrictToParentElement]}
      onDragStart={hanldeDragStart}
      onDragCancel={() => menuGroupEditStore.setDraggingCategory(null)}
      onDragEnd={handleDragEnd}
    >
      <ScrollableBlock
        showScrollbar
        scrollbarSize="small"
        direction="horizontal"
        className="menu-group-categories"
        scrollClassName="menu-group-categories__scroll gap-10 w-fit-content"
      >
        {categories.map((category, index) => (
          <DraggableCategory
            id={category.id}
            key={category.id}
            index={index}
            category={category}
            isSelected={category.id === menuGroupEditStore.selectedCategoryId}
          />
        ))}
      </ScrollableBlock>

      <DragOverlay dropAnimation={dndOverlayAnimationDefault}>
        {menuGroupEditStore.draggingCategory ? (
          <DraggableCategory
            id={0}
            key="draggable-category"
            index={-1}
            category={menuGroupEditStore.draggingCategory}
            className="draggable-category_active"
            isSelected={false}
          />
        ) : null}
      </DragOverlay>
    </DndContext>
  );
});

export default MenuGroupCategories;
